// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, object, string } from 'prop-types'
import AggregateGroup from './AggregateGroup'

const FieldArrayWrapper = ({ callsignCascadeData, fields, idRoot }) => (
  <div className={'flex-1 overflow-auto padding-bottom-half padding-top-half'}>
    {
      fields.map((d, i) => (
        <AggregateGroup
          key={d}
          groupData={callsignCascadeData[i]}
          idRoot={`${idRoot}-${d}`}
          nameRoot={d} />
      ))
    }
  </div>
)

FieldArrayWrapper.propTypes = {
  callsignCascadeData: array.isRequired,
  fields: object.isRequired,
  idRoot: string.isRequired,
}

export default FieldArrayWrapper
